headerController.$inject = [
  "$http",
  "$auth",
  "$scope",
  "$rootScope",
  "ngIntroService",
  "$sce",
  "$state",
  "$stateParams",
  "$resource",
  "$location"
];
import { medalList } from "./medal/medal"

function headerController($http, auth, scope, rootScope, ngIntroService, $sce, $state, $stateParams, $resource, $location) {
  var self = this;
  self.personSearchLoading = false;
  self.searchBoxShown = false;
  rootScope.lastAdmissionRequests = [];
  self.locationOrigin = window.location.origin;
  self.panelTypes = "";

  scope.$watch(
    function () {
      return rootScope.IntroOptions;
    },
    function (newValue) {
      self.IntroOptions = newValue;
    }
  );

  self.startGuide = function () {
    ngIntroService.clear();
    ngIntroService.setOptions(self.IntroOptions);
    ngIntroService.start();
  };

  self.logout = function () {
    auth.signoutRedirect();
  };
  self.trustHtml = function (html) {
    return $sce.trustAsHtml(html);
  }

  function getNotificationText(notifText) {
    let notifType = notifText.substring(0, 3);
    switch (notifType) {
      case "KRG":
        notifType = "MarketDefinitivePrice";
      case "KRT":
        notifType = "MarketAgreementPrice";
      case "MRA":
        notifType = "MarketReceiveAccept";
      case "MRR":
        notifType = "MarketReceiveReject";
      default:
        notifType = "Normal";
    }
    if (notifType == "Normal")
      notifText = notifText.substring(4, notifText.length - 4);
    return notifText;
  }
  //get medal List
  self.medal = medalList() // !!!!;




  auth.getUser().then(async function (user) {
    self.user_id = user.profile.user_id;
    self.panelTypes = user.profile.user_type;
    self.preferred_username = user.profile.preferred_username;
    if (user) {
      console.log(user);

      self.userType = user.profile.user_type;
      rootScope.userType = user.profile.user_type;
      self.username = user.profile.name;

      $http.defaults.headers.common.Authorization =
        "Bearer " + user.access_token;

      // if (self.test(user) != null) {
      //   rootScope.noticesList = self.test(user).content;
      //   rootScope.noticesList.forEach(notice => {
      //     notice.text = getNotificationText(notice.text);

      //   })
      // }
       self.test(user);
      



      self.getPersonalPage = function () {
        $http({
          method: "GET",
          url: `${apiGetWay}PersonalPageAddress?userId=${self.user_id}`,
          ignoreLoadingBar: true,
        }).then(function (response) {
          $("body").append(response.data.content)
        });
      }


      scope.$watch('self.preferred_username', function () {
        self.getDaneshBonyanMedal();
        self.getMedal();

      });


      self.getMedal = function () {
        $http({
          method: "GET",
          url: `${apiGetWay}PersonTypes`,
          ignoreLoadingBar: true,
        }).then(response => {
          self.userMedal = response.data.content;

          console.log(self.userMedal);

          for (const key of self.userMedal) {
            self.medal.forEach(element => {
              if (element.englishName == key.medalTitle) {
                element.hasMedal = true;
              }
            });
          }
          // for (const key in self.userMedal) {
          //     self.medal.forEach(element => {
          //         if (element.englishName == self.userMedal[key].medalTitle) {
          //             element.hasMedal = true;
          //         }
          //     });
          // }
        });
        console.log(self.medal);

        console.log("Test await Ok");
      }



      self.getDaneshBonyanMedal = function () {

        $http({
          method: "GET",
          url: `${apiGetWay}legalPersonDaneshbonyan?nationalId=${self.preferred_username}`,
          ignoreLoadingBar: true,
        }).then(response => {
          if (response.data.content == true) {
            self.medal[1].hasMedal = true;

          }
        });

      }




      // self.getPersonalPage = function () {
      //   $http({
      //     method: "GET",
      //     url: `${apiGetWay}PersonalPageAddress`,
      //     ignoreLoadingBar: true,
      //     params:{
      //       userId:self.user_id
      //     },
      //   }).then(function (response) {
      //     var item=response.data.content
      //     var node = document.createElement('p');
      //     node.innerHTML=item.trim();
      //     document.getElementsByTagName('body')[0].append(node)
      //     document.body.appendChild(response.content)
      //   });
      // }






      // $http({
      //   method: "GET",
      //   url: `${apiGetWay}NotificationList?notificationType=1`,
      //   ignoreLoadingBar: true
      // }).then(function (response) {
      //   rootScope.noticesList = response.data.content;
      //   // rootScope.noticesList.forEach(notice => {
      //   //   notice.text = getNotificationText(notice.text);
      //   // });
      // });

      $http({
        method: "GET",
        url: `${apiGetWay}PersonTypes`
      }).then(function (response) {
        rootScope.userTypes = response.data.content;
        rootScope.hasSettingAccess = false;
        rootScope.userMedals = [];
        rootScope.userTypes.forEach(userType => {
          if (userType.medalTitle == "accelerator" || userType.medalTitle == "co_work") {
            rootScope.hasSettingAccess = true;
            self.hasSettingAccess = true;
            rootScope.userMedals.push(userType.medalTitle);
          }
        })
      });

      // $http({
      //   method: "GET",
      //   url: `${apiGetWay}ReceivedAdmissionRequests?pageSize=3&pageIndex=1&status=0&companyType=1`
      // }).then(function (response) {
      //   if (response.data.data != null) {
      //     rootScope.lastAdmissionRequests = rootScope.lastAdmissionRequests.concat(response.data.data);
      //   }
      // });

      // $http({
      //   method: "GET",
      //   url: `${apiGetWay}ReceivedAdmissionRequests?pageSize=3&pageIndex=1&status=0&companyType=2`
      // }).then(function (response) {
      //   if (response.data.data != null) {
      //     rootScope.lastAdmissionRequests = rootScope.lastAdmissionRequests.concat(response.data.data)
      //   }
      // });



      $http({
        method: "GET",
        url: `${apiGetWay}/micro/mailbox/incomingMessages/Unreads`
      }).then(function (response) {
        rootScope.receivedMessages = response.data.content;
      });
    }
  });

  self.test = function (user) {
    async function postData(url = '', data = {}) {
      // Default options are marked with *
      const response = await fetch(url, {
        method: 'get', // *GET, POST, PUT, DELETE, etc.
        ignoreLoadingBar: true,
        headers: {
          "Authorization": 'Bearer ' + user.access_token,
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      return await response.json(); // parses JSON response into native JavaScript objects
    }

    postData(`${apiGetWay}NotificationList?notificationType=1`)
      .then((data) => {
        rootScope.noticesList= data.content
        console.log(rootScope.noticesList); // JSON data parsed by `response.json()` call
      });

  }




  scope.$watch(
    function () {
      return rootScope.broadcast;
    },
    function (newValue) {
      self.broadcast = newValue;
    }
  );

  scope.$watch(
    function () {
      return rootScope.currentState;
    },
    function (newValue) {
      self.currentState = newValue;
    }
  );

  scope.$watch(
    function () {
      return rootScope.noticesList;
    },
    function (newValue) {
      self.noticesList = newValue;
    }
  );

  scope.$watch(
    function () {
      return rootScope.lastAdmissionRequests;
    },
    function (newValue) {
      self.lastAdmissionRequests = newValue;
    }
  );

  scope.$watch(
    function () {
      return rootScope.receivedMessages;
    },
    function (newValue) {
      self.receivedMessages = newValue;
    }
  );

  let targetLocationHrefHandler = function (route, id) {
    if (location.hostname == "localhost") {
      return `${location.origin + route}${id ? id : ""}`;
    } else
      return `${location.origin}/${rootScope.userType + route}${id ? id : ""}`;
  };

  self.goToNoticesList = function () {
    location.href = targetLocationHrefHandler("/#!/Notices/List");
  };

  function getObjectLength(object) {
    var length = 0;
    for (var key in object) {
      if (object.hasOwnProperty(key)) {
        ++length;
      }
    }
    return length;
  };

  self.goToNoticesDetails = function (id) {
    if (getObjectLength($stateParams) > 1)
      $state.go("Notices.Details", { id: id });
    else
      $state.go("Notices.Details", { id: id, previousState: $state.current.name });
  };

  self.goToInbox = function () {
    location.href = targetLocationHrefHandler("/#!/Mailing/Mail/Inbox");
  };

  self.goToMessage = function (id) {
    location.href = targetLocationHrefHandler("/#!/Mailing/Mail/Inbox/", id);
  };

  self.goToJoinRequestReceive = function () {
    location.href = targetLocationHrefHandler(
      "/#!/Accelerator/JoinRequestReceive"
    );
  };

  self.goToJoinRequestReceiveDetail = function (row) {
    if (row.requestType == 'co_work')
      location.href = targetLocationHrefHandler(
        "/#!/CoWork/JoinRequestReceiveDetail/",
        row.id
      );
    if (row.requestType == 'accelerator')
      location.href = targetLocationHrefHandler(
        "/#!/Accelerator/JoinRequestReceiveDetail/",
        row.id
      );
  };

  self.goToContact = function () {
    location.href = targetLocationHrefHandler("/#!/GeneralInfo/Contact");
  };

  self.showSearchbox = function (show) {
    if (show == true) {
      self.searchBoxShown = true;
    }
    else {
      self.searchBoxShown = false;
    }
  }
  self.searchPersons = function () {
    self.personsSearchResults = [];
    if (self.personSearchText == "" || self.personSearchText == null) {
      self.showSearchbox(false);
      return;
    }
    if (!self.searchBoxShown)
      self.showSearchbox(true);
    self.personSearchLoading = true;
    $http({
      method: "GET",
      url: `${apiGetWay}PersonalPagePersons?pageSize=5&search=${self.personSearchText}`,
      ignoreLoadingBar: true
    }).then(function (response) {
      self.personsSearchResults = response.data.persons;
      self.personSearchLoading = false;
    });
  }

  $("body").on("click", function (e) {
    if ($(e.target).closest('.search-box').length == 0 && $(e.target).closest('.search-input').length == 0) {
      self.showSearchbox(false);
    }
  });

  //show Button Reset
  self.showresetbutton = false;
  rootScope.showResetButton = function () {
    self.showresetbutton = self.showresetbutton ? false : true;
  }
  //reset Doshboard
  self.reset = function () {
    rootScope.resetDashboard();
  }
}

export {
  headerController
};